module.exports = __webpack_public_path__ + "static/media/faq-header-desktop.6fea5b89.jpg";